import { type ApiResponseData } from '@/common/types/http'
import axios, { type AxiosResponse, type AxiosError } from 'axios'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isApiResponseData = (dataToken: any): dataToken is ApiResponseData => {
  return !!dataToken && typeof dataToken === 'object' && 'key' in dataToken
}

export const isApiError = (error: unknown): boolean => {
  if (axios.isAxiosError(error)) {
    return isApiResponseData(error.response?.data)
  }
  return false
}

export const getApiErrorResponse = (error: unknown): AxiosResponse<ApiResponseData> | undefined => {
  if (!isApiError(error)) throw new Error('Error is not an API error')
  return (error as AxiosError<ApiResponseData>).response
}
